import { render, staticRenderFns } from "./MailRecord.vue?vue&type=template&id=219677c8"
import script from "./MailRecord.vue?vue&type=script&lang=js"
export * from "./MailRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports